import React from "react";
import styles from "./PullModal.module.scss";
import Image from "next/image";
import CloseImg from "../../../../public/images/cancel.png";

interface PullModal {
  children: React.ReactNode;
  onClose: () => void;
}

const PullModal = ({ children, onClose }: PullModal) => {
  return (
    <div className={styles.mainWrapper}>
      <div
        className={styles.modalBg}
        onClick={e => {
          e.stopPropagation();
          onClose();
        }}
      ></div>

      <div className={styles.modalWrapper}>
        <div className={styles.closeBtn} onClick={onClose}>
          <Image src={CloseImg} layout="fill" alt="" />
        </div>

        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>
  );
};

export default PullModal;
